import { css } from 'styled-components';
import { MobilePanelButtonStyle } from '../../../../../../components/TabPanels/MobileTabPanels/MobilePanelButton/styles';
import { SubPanelButtonProps } from '../../../../../../components/TabPanels/types';
import { colors, themeSpecificColors } from '../../../../colors';

export default css<SubPanelButtonProps>`
  &${MobilePanelButtonStyle} {
    &:hover {
      background: ${themeSpecificColors.core01_10};
      background: ${({ isSelected }) =>
        isSelected ? `${colors.core02}` : `${themeSpecificColors.core01_10}`};
    }
    &:focus-visible {
      outline: solid ${themeSpecificColors.core01_60} 4px;
    }
  }
`;
